<template>
  <!-- 套利成交明细 -->
  <div v-show="isShow">
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">套利成交明细</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="businessTime"
        label="时间"
      />
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="businessAmount"
        label="数量(笔)"
      />
      <af-table-column
        prop="dayTradeAmount"
        label="变今单量(笔)"
      />
      <af-table-column
        prop="entrustTsDesc"
        label="订/变"
      />
      <af-table-column
        prop="entrustBsDesc"
        label="购/销"
      />
      <af-table-column
        prop="businessPriceMargin"
        label="成交差价"
      />
      <af-table-column
        prop="closeProfit"
        label="预计当日补偿金"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
    <br><br>
  </div>
</template>

<script>
import api from '@/api'
import dayJs from 'dayjs'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'ArbitrageTransactionDetails',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '客户号',
        excelColumn: 'tradeUserAccount'
      },
      {
        fieldLabel: '时间',
        excelColumn: 'businessTime'
      },
      {
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '数量(笔)',
        excelColumn: 'businessAmount'
      },
      {
        fieldLabel: '变今单量(笔)',
        excelColumn: 'dayTradeAmount'
      },
      {
        fieldLabel: '订/变',
        excelColumn: 'entrustTsDesc'
      },
      {
        fieldLabel: '购/销',
        excelColumn: 'entrustBsDesc'
      },
      {
        fieldLabel: '成交差价',
        excelColumn: 'businessPriceMargin'
      },
      {
        fieldLabel: '预计当日补偿金',
        excelColumn: 'closeProfit'
      },
      {
        fieldLabel: '贸易公司',
        excelColumn: 'tradeCompanyCode'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      isShow: false,

      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_套利成交明细',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDay = param.date ? dayJs(this.query.date).format('YYYYMMDD') : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.ArbitrageTransactionDetails(param)
      this.allData = res.data || []
      this.isShow = !(this.allData.length === 0 || (this.allData.length === 1 && this.allData[0]['tradeUserAccount'] === '合计'))
    },
  }
}

</script>
